import { type Product } from 'types/products/productTypes'
import * as React from 'react'

type Props = {
  isMoudHomeDelivery: boolean
}
export function useGetOrderNameFromProduct({ isMoudHomeDelivery }: Props) {
  const getOrderNameFromProduct = React.useCallback(
    (product?: Product) => {
      if (!product) return ''
      const { Brand, Variation, Name, Options } = product

      const homeDeliveryOptionDose = Options[0]?.ShortName?.replace(/(.*?mg).*$/i, '$1') || '8-2MG'
      return isMoudHomeDelivery ?
          `${Name} (${homeDeliveryOptionDose})`
        : (Brand === 'Generic' ? Variation : Brand)
    },
    [isMoudHomeDelivery],
  )

  return { getOrderNameFromProduct }
}
